exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr.checked[data-v-91a58134], tr.checked[data-v-91a58134]:hover {\n    background-color: #0094ff !important;\n    color: #fff;\n}\n", ""]);

// exports
